import { queryParams, type RouteQueryOptions, type RouteDefinition, applyUrlDefaults } from './../../../wayfinder'
/**
* @see \App\Http\Controllers\Brand\AccountController::index
* @see app/Http/Controllers/Brand/AccountController.php:26
* @route '/brands/{brand}/accounts'
*/
export const index = (args: { brand: string | { id: string } } | [brand: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: index.url(args, options),
    method: 'get',
})

index.definition = {
    methods: ["get","head"],
    url: '/brands/{brand}/accounts',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Brand\AccountController::index
* @see app/Http/Controllers/Brand/AccountController.php:26
* @route '/brands/{brand}/accounts'
*/
index.url = (args: { brand: string | { id: string } } | [brand: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { brand: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { brand: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            brand: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        brand: typeof args.brand === 'object'
        ? args.brand.id
        : args.brand,
    }

    return index.definition.url
            .replace('{brand}', parsedArgs.brand.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Brand\AccountController::index
* @see app/Http/Controllers/Brand/AccountController.php:26
* @route '/brands/{brand}/accounts'
*/
index.get = (args: { brand: string | { id: string } } | [brand: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: index.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Brand\AccountController::index
* @see app/Http/Controllers/Brand/AccountController.php:26
* @route '/brands/{brand}/accounts'
*/
index.head = (args: { brand: string | { id: string } } | [brand: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: index.url(args, options),
    method: 'head',
})

const accounts = {
    index: Object.assign(index, index),
}

export default accounts